import type { IUniversalMenuItemCTA } from '@klv/shared/types';
import { UniversalMenuItem } from '@klv/molecules/universal-menu-item';
import { DropdownButton } from '@klv/molecules/dropdown-button';
import { generateClassName } from '@klv/shared/utils/functions';
import { useTranslation } from '@klv/hooks/useTranslation';
import { getAcademyIframeSource } from '@klv/shared/utils/academyIframeSource';
import { loginActions } from '../../utils';
import * as styles from '../../styles/universalNavigation.module.css';

interface IAcademyCTAList {
  academyLoggedIn?: boolean;
  ctas?: IUniversalMenuItemCTA[];
  className?: string;
  onLogout?: () => void;
  profileHref?: string;
  profileLabel?: string;
  credentialsLabel?: string;
  logoutLabel?: string;
  logoutHref?: string;
}

export const AcademyCTAList = ({
  academyLoggedIn = false,
  ctas = [],
  className = '',
  onLogout,
  profileHref,
  profileLabel,
  credentialsLabel,
  logoutLabel,
  logoutHref,
}: IAcademyCTAList) => {
  const { t } = useTranslation();

  const handleLogout = () => {
    if (onLogout) {
      onLogout();
    } else {
      localStorage.removeItem('skilljarUser');
      localStorage.removeItem('viewedResources');
      sessionStorage.removeItem('lastViewedAcademyContent');
      window.location.replace(`${getAcademyIframeSource()}${logoutHref || t('navigation_ecosystem_ctas_academy_logOut_href')}`);
    }
  };

  return (
    <ul className={generateClassName([styles.list, styles.ctaList, className])}>
      {academyLoggedIn ? (
        <li className={styles.ctaListItem}>
          <DropdownButton
            children={
              <a href={profileHref || t('navigation_ecosystem_ctas_academy_profile_href')}>
                {profileLabel || t('navigation_ecosystem_ctas_academy_profile_label')}
              </a>
            }
            dropdownItems={[
              <a href='https://v2.accounts.accredible.com/retrieve-credentials' target='_blank'>
                {credentialsLabel || t('navigation_ecosystem_ctas_academy_myCredentials_label')}
              </a>,
              <button
                className={styles.academyLogoutButton}
                onClick={handleLogout}
              >
                {logoutLabel || t('navigation_ecosystem_ctas_academy_logOut_label')}
              </button>,
            ]}
            dropdownName='profile-actions'
          />
        </li>
      ) : (
        ctas.map(({ id, label, variant, url, ...rest }) => (
          <li className={styles.ctaListItem} key={id}>
            <UniversalMenuItem
              className={generateClassName([
                styles.cta,
                variant && styles[variant],
              ])}
              href={url}
              label={label}
              onClick={() => loginActions({ childItem: label })}
              {...rest}
            />
          </li>
        ))
      )}
    </ul>
  );
};
